<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'数据统计'},{name:'用户统计'}]" :title="'用户统计'"/> -->
            <!-- 统计 -->
            <div class="statistics" ref="statistics">
                <ul>
                    <li>
                        <div class="name">用户数</div>
                        <div class="num">{{statisticalNum.userTotal}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">已认证</div>
                        <div class="num">{{statisticalNum.certifiedNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">个人客户</div>
                        <div class="num">{{statisticalNum.consumerClientNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">企业客户</div>
                        <div class="num">{{statisticalNum.corporateClientsNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">银行</div>
                        <div class="num">{{statisticalNum.bankNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">投资机构/投资人</div>
                        <div class="num">{{statisticalNum.institutionalInvestorNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">政府部门</div>
                        <div class="num">{{statisticalNum.governmentDepartmentNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">孵化器</div>
                        <div class="num">{{statisticalNum.incubatorNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">融资租赁公司</div>
                        <div class="num">{{statisticalNum.financeLeasingCompanyNum}}<span>个</span></div>
                    </li>
                    <li>
                        <div class="name">担保公司</div>
                        <div class="num">{{statisticalNum.guaranteeCompanyNum}}<span>个</span></div>
                    </li>
                </ul>
            </div>
            <div class="condition">
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">筛选日期</span>
                        <el-date-picker
                                size="small"
                                v-model="sendInfoOne.time"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                    
                </div>
                <div class="right">
                  <el-button  size="small" @click="exportFile" icon="m-icon-upload" v-if="authorities.indexOf('sys:permission:background:user:statistics:list:button:export')!=-1">导出</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                    :data="tableData"
                    ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        show-overflow-tooltip
                        
                        label="日期">
                </el-table-column>
                <el-table-column
                        prop="addRegisterNum"
                        show-overflow-tooltip
                        
                        label="新增注册数">
                </el-table-column>
                <el-table-column
                        prop="loginUserNum"
                        show-overflow-tooltip
                        
                        label="登录用户数">
                </el-table-column>
                <el-table-column
                        prop="totalRegisterNum"
                        show-overflow-tooltip
                        
                        label="累积新增注册数">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                        :PageData="PageData"
                        @nextpage="nextpage"
                        @previouspage="previouspage"
                        @handleSizeChange="handleSizeChange"
                        @handleCurrentChange="handleCurrentChange">
                </Paging>
            </div>
            </div>
        </div>
</template>

<script>
    // import breadcrumb from '../../components/breadcrumb';
    import Paging from '../../components/Paging';

    export default {
        components: {
            // breadcrumb, 
            Paging
        },
        data() {
            return {
                loading:false,
                bHeight: void 0,
                authorities:JSON.parse(window.localStorage.getItem('authorities')),
                sendInfoOne: {
                    time: '',//日期
                },//搜索
                sendInfo: {
                    currentPage: 1,//当前页
                    pageSize: 10,//页条数
                    property: null,//排序字段
                    direction: 'DESC', //排序排序方式DESC降 ASC升
                    endTime: null,//结束时间
                    startTime: null,//开始时间
                },
                exportInfo: {
                    endTime: null,//结束时间
                    startTime: null,//开始时间
                },
                PageData: {
                    currentPage: 0,
                    total: 0, //多少條
                },
                statisticalNum: [],//用户角色统计
                tableData: [],//表格
                currentPage: 1,//当前页
            }
        },
        methods: {
          onReset(){
            this.sendInfoOne.time = void 0
            this.exportInfo.startTime = void 0
            this.exportInfo.endTime = void 0
            const param = {
              currentPage: 1,//当前页
                    pageSize: 10,//页条数
                    property: null,//排序字段
                    direction: 'DESC', //排序排序方式DESC降 ASC升
                    endTime: null,//结束时间
                    startTime: null,//开始时间
            }
            this.sendInfo = Object.assign(this.sendInfo,param)
            this.getList()
          },
          doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
            //统计
            statistical: function () {
                this.$axiosz.get('backstage/sysUser/role/statistical').then((r) => {
                    if (r.code == 200) {
                        this.statisticalNum = r.data;
                    } else {
                        this.$alert(r.msg)
                    }
                })
            },
            //获取列表
            getList: function () {
                this.loading = true
                this.$axiosz.get('backstage/sysUser/statistical', {params: this.sendInfo}).then(res => {
                    
                    if (res.code == 200) {
                        this.tableData = res.data.content;
                        this.PageData.currentPage = res.data.currentPage; //当前页
                        this.PageData.total = res.data.totalElements;
                        this.loading = false
                    } else {
                        this.$alert(res.msg)
                        this.loading = false
                    }
                }).catch(e=>{
                  this.loading = false
                })
            },
            //导出
            exportFile: function () {
                this.dateToConversion();
                this.$axiosz.get('backstage/sysUser/statistical/export', {params: this.exportInfo}).then(res => {
                    if (res.code == 200) {
                        var aLink = document.createElement('a');
                        var blob = this.dataURLtoBlob(res.data.bytes);
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);   // 转换为base64，可以直接放入a标签href
                        reader.onload = function (e) {
                            var a = document.createElement('a');   // 转换完成，创建一个a标签用于下载
                            a.download = res.data.fileName;
                            a.href = e.target.result;
                            document.body.appendChild(a);    // 修复firefox中无法触发click
                            a.click();
                            document.body.removeChild(a);
                        }
                    } else {
                        this.$alert(res.msg)
                    }
                })
            },
            dataURLtoBlob: function (dataurl) {
                let bstr = atob(dataurl),//负责解码已经使用base64编码了的字符串
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: 'application/vnd.ms-excel;charset=UTF-8;'});
            },
            //查询
            retrieval: function () {
                this.dateToConversion();
                this.getList();
            },

            //日期转换
            dateToConversion:function(){
                let lookData = this.sendInfoOne;
                if (lookData.time && lookData.time.length > 0) {
                    this.sendInfo.startTime = lookData.time[0]
                    this.sendInfo.endTime = lookData.time[1]
                    this.exportInfo.startTime = lookData.time[0]
                    this.exportInfo.endTime = lookData.time[1]
                } else {
                    this.sendInfo.startTime = null;
                    this.sendInfo.endTime = null;
                    this.exportInfo.startTime = null;
                    this.exportInfo.endTime = null;
                }
            },

            // 下一頁
            nextpage(val) {
                this.sendInfo.currentPage = val;
                this.getList();
            },
            // 上一頁
            previouspage(val) {
                this.sendInfo.currentPage = val;
                this.getList();
            },
            handleSizeChange(val) {
                this.sendInfo.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.sendInfo.currentPage = val;
                this.sendInfo.currentPage = val;
                this.getList()
            },
        },
        created() {
            this.statistical();
            this.getList();
        },
        mounted(){
          const that= this
          let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 +(that.$refs.statistics?that.$refs.condition.offsetHeight:0)
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + (that.$refs.statistics?that.$refs.condition.offsetHeight:0)
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
        },
        computed:{
            errors() {
                return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
            }
        }
    }
</script>


<style lang="scss" scoped>
.main{
  background: transparent !important;
  padding:0 !important;
  .condition{
    background: #fff;
    margin-top:16px;
    padding:16px;
    .retrieve{
      justify-content: space-between;
      flex-direction: row;
    }
    .el-button--default{
      color:#595959;
    }
  }
}
</style>